import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy Connectors route. The Connectors admin page moved under Integrations
 * (`/integrations/connectors`); redirect the old Platform URL so existing links
 * and bookmarks don't 404.
 */
export const Route = createFileRoute('/_authenticated/_tenant/platform/connectors')({
  beforeLoad: () => {
    // TanStack Router uses throw redirect() as control flow — not an error.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/integrations/connectors' });
  },
});
